import { combineReducers } from "redux";
import { session, login, LoginState, SessionState } from "../Login/State";
import {
  SettingsMarketsGrid,
  settingsMarketsGrid,
  SettingsColours,
  settingsColours,
  ActiveTradingAccount,
  activeTradingAccount,
  tradingAccounts,
  ClientAccount,
  clientAccount,
  linkedTradingAccounts
} from "../Platform/State";
import { TradingAccount } from "swan-public-api-client";

export interface AppState {
  login: LoginState;
  session: SessionState;
  settingsMarketsGrid: SettingsMarketsGrid;
  settingsColours: SettingsColours;
  clientAccount: ClientAccount,
  activeTradingAccount: ActiveTradingAccount;
  tradingAccounts: TradingAccount[];
  linkedTradingAccounts: TradingAccount[];
}

export const rootReducer = combineReducers({
  login,
  session,
  settingsMarketsGrid,
  settingsColours,
  clientAccount,
  activeTradingAccount,
  tradingAccounts,
  linkedTradingAccounts
});
